import { create } from 'zustand'

export type ToastKind = 'success' | 'error' | 'warning' | 'info'

export interface Toast {
  id: string
  kind: ToastKind
  title: string
  message?: string
  durationMs: number
}

interface ToastState {
  toasts: Toast[]
  push: (kind: ToastKind, title: string, message?: string, durationMs?: number) => void
  remove: (id: string) => void
  clear: () => void
}

/** Toasts (CRM kit rule 4) in a small zustand store, so any code can notify without a hook. */
export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (kind, title, message, durationMs) => {
    const id = `t_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`
    const ms = durationMs ?? (kind === 'error' ? 6000 : 3500)
    set((s) => ({ toasts: [...s.toasts, { id, kind, title, message, durationMs: ms }] }))
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })), ms)
  },
  remove: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
  clear: () => set({ toasts: [] }),
}))

export const notify = {
  success: (title: string, message?: string) => useToastStore.getState().push('success', title, message),
  error: (title: string, message?: string) => useToastStore.getState().push('error', title, message),
  warning: (title: string, message?: string) => useToastStore.getState().push('warning', title, message),
  info: (title: string, message?: string) => useToastStore.getState().push('info', title, message),
}
